<template>
  <div id="app">
    <homePage />
  </div>
</template>

<script>
import homePage from './components/homePage.vue'

export default {
  name: 'App',
  components: {
    homePage
  },
  mounted() {
    document.title = `方穹科技`;
  }
}
</script>


<style>
</style>
